<template>
<div style="max-width: 700px;">
  <b-card :title="user.name" :sub-title="user.position">
    <b-card-text>
  <div class="row">
    <div class="col-md-3" style="display:none;">
      <div class="user-avatars mb-2">
        <div
          class="user_avatars_image w-100"
          @click="showModalUploadPhoto('show')"
        >
          <template v-if="currentUser.avatar_path">
            <img :src="currentUser.avatar_path" alt="avatar" class="w-100" />
          </template>
          <template v-else>
            <img :src="'/img/not-avatar.svg'" alt="avatar" class="w-100" />
          </template>
          <div
            class="
              position-absolute
              user_avatars_info
              text-center
              cursor-pointer
            "
          >
            <span> Обновить фотографию </span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="row mt-4">
        <div class="col-md-12">
          <div class="profile_info_block">
            <div class="profile_info_header_wrap position-relative">
              <span class="profile_info_header text-brown">Ваш профиль</span>
              
              <div class="d-flex gap-2 edit-button">
                <b-button 
                  @click="showPasswordChange = !showPasswordChange"
                  v-if="!editMode && !loadingData"
                  variant="outline-secondary"
                  size="sm"
                >
                  <span class="d-none d-md-block">Сменить пароль</span>
                  <span class="d-block d-md-none"><i class="fas fa-key"></i></span>
                </b-button>
                
                <b-button 
                  @click="toggleEditMode"
                  class="ml-2"
                  v-if="!editMode && !loadingData"
                >
                  <span class="d-none d-md-block">Редактировать</span>
                  <span class="d-block d-md-none"><i class="fas fa-edit"></i></span>
                </b-button>
              </div>
            </div>
            <div class="profile_info mt-3" v-if="!editMode">
              <div class="d-flex profile_info_label">
                <div class="label">Телефон:</div>
                <div>+{{ user.phone }}</div>
              </div>
              <div class="d-flex profile_info_label">
                <div class="label">Почта:</div>
                <div>{{ user.email }}</div>
              </div>
              <div class="d-flex profile_info_label">
                <div class="label">Должность:</div>
                <div>{{ user.position }}</div>
              </div>
            </div>
            <div class="profile_info mt-3" v-if="editMode">
              <div class="d-flex profile_info_label mt-2">
                <div class="label">Ваше имя и фамилия:</div>
                <b-form-input v-model="user.name" size="sm" required class="form-control" />
              </div>
              <div class="d-flex profile_info_label mt-2">
                <div class="label">Телефон:</div>
                <b-form-input v-mask="`+# (###) ###-##-##`" v-model="user.phone" size="sm" required class="form-control" />
              </div>
              <div class="d-flex profile_info_label mt-2">
                <div class="label">Почта:</div>
                <b-form-input v-model="user.email" disabled title="Может быть отредактирован только администратором" size="sm" type="email" required class="form-control" />
              </div>
              <div class="d-flex profile_info_label mt-2">
                <div class="label">Должность:</div>
                <b-form-input v-model="user.position" size="sm" required class="form-control" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Форма смены пароля -->
      <div class="row mt-2" v-if="showPasswordChange">
        <div class="col-md-12">
          <div class="profile_info_block">
            <div class="profile_info_header_wrap position-relative">
              <span class="profile_info_header text-brown">Смена пароля</span>
            </div>
            <div class="profile_info mt-3">
              <PasswordChangeForm @cancel="showPasswordChange = false" />
            </div>
          </div>
        </div>
      </div>      

      <div class="row mt-2" v-if="!isLeadObserver">
        <div class="col-md-12">
          <div class="profile_info_block">
            <div class="profile_info_header_wrap position-relative">
              <span class="profile_info_header text-brown">Почтовые настройки</span>
              
              <!-- <b-button 
                @click="toggleEditMode"
                v-if="!editMode && !loadingData"
                class="edit-button"
              >Редактировать</b-button> -->
            </div>
            
            <b-overlay 
              :show="loadingData"
              opacity="1"
              style="min-height: 400px;"
            >
              <div class="profile_info mt-3" v-if="!editMode && !loadingData">
                <div class="d-flex profile_info_label">
                  <div class="label">SMTP Host:</div>
                  {{ smtpSettings.smtp_host || 'Не указано' }}
                </div>
                <div class="d-flex profile_info_label">
                  <div class="label">SMTP Port:</div>
                  {{ smtpSettings.smtp_port || 'Не указано' }}
                </div>
                <div class="d-flex profile_info_label">
                  <div class="label">SMTP Username (Почта):</div>
                  {{ smtpSettings.smtp_username || 'Не указано' }}
                </div>
                <div class="d-flex profile_info_label">
                  <div class="label">SMTP Пароль:</div>
                  <template v-if="smtpSettings.smtp_password">Пароль указан и скрыт</template>
                  <template v-else>Не указан</template>
                </div>
                <div class="d-flex profile_info_label">
                  <div class="label">SMTP Шифрование:</div>
                  {{ smtpSettings.smtp_encryption || 'Не указано' }}
                </div>
                <div class="d-flex profile_info_label">
                  <div class="label">IMAP Host:</div>
                  {{ smtpSettings.pop_host || 'Не указано' }}
                </div>
                <div class="d-flex profile_info_label">
                  <div class="label">IMAP Port:</div>
                  {{ smtpSettings.pop_port || 'Не указано' }}
                </div>
                <div class="d-flex profile_info_label">
                  <div class="label">IMAP Username (Почта):</div>
                  {{ smtpSettings.pop_username || 'Не указано' }}
                </div>
                <div class="d-flex profile_info_label">
                  <div class="label">IMAP Пароль:</div>
                  <template v-if="smtpSettings.pop_password">Пароль указан и скрыт</template>
                  <template v-else>Не указан</template>
                </div>
                <div class="d-flex profile_info_label">
                  <div class="label">IMAP Шифрование:</div>
                  {{ smtpSettings.pop_encryption || 'Не указано' }}
                </div>
                <div class="d-flex profile_info_label">
                  <div class="label" style="line-height: 16px;">Ваша подпись<br>будет выглядеть так:</div>
                   <div class="email-sign">
                      --<br>
                      <b>С уважением, <br>
                      {{ user.name }}</b><br>
                      {{ user.position }}<br>
                      АО "ТАНАИС Брокер"<br>
                      <br>
                      <a :href="`tel:+${user.phone}`">{{ user.formatted_phone ? user.formatted_phone : user.phone }}</a><br>
                      <a :href="`mailto:${user.email}`" class="moz-txt-link-freetext">{{ user.email }}</a> <br>
                      Москва, Горбунова д.2, стр.3<br>
                      БЦ "Гранд Сетунь плаза"<br>
                      <br>
                      <img src="http://eu-tanais.com/logo-tanais.jpg" alt="" width="200"><br>
                   </div>
                </div>               
              </div>

              <div class="profile_info mt-3" v-if="editMode">
                <div class="d-flex profile_info_label">
                  <div class="label">Шаблон настроек:</div>
                  <b-form-select 
                    v-model="smtpSettings.name" 
                    size="sm" required 
                    :options="typeList"
                  ></b-form-select>
                </div>

                <div class="d-flex profile_info_label mt-2">
                  <div class="label">SMTP Host:</div>
                  <b-form-input v-model="smtpSettings.smtp_host" size="sm" required class="form-control" />
                </div>
                <div class="d-flex profile_info_label mt-2">
                  <div class="label">SMTP Port:</div>
                  <b-form-input v-model="smtpSettings.smtp_port" size="sm" required class="form-control" type="number" />
                </div>
                <div class="d-flex profile_info_label mt-2">
                  <div class="label">SMTP Username (Почта):</div>
                  <b-form-input v-model="smtpSettings.smtp_username" disabled size="sm" required class="form-control" />
                </div>
                <div class="d-flex profile_info_label mt-2">
                  <div class="label">SMTP Пароль:</div>
                  <b-form-input v-model="smtpSettings.smtp_password" size="sm" required class="form-control" type="password" />
                </div>
                <div class="d-flex profile_info_label mt-2">
                  <div class="label">SMTP Шифрование:</div>
                  <b-form-input v-model="smtpSettings.smtp_encryption" size="sm" required class="form-control" />
                </div>
                <div class="d-flex profile_info_label mt-2">
                  <div class="label">IMAP Host:</div>
                  <b-form-input v-model="smtpSettings.pop_host" size="sm" required class="form-control" />
                </div>
                <div class="d-flex profile_info_label mt-2">
                  <div class="label">IMAP Port:</div>
                  <b-form-input v-model="smtpSettings.pop_port" size="sm" required class="form-control" type="number" />
                </div>
                <div class="d-flex profile_info_label mt-2">
                  <div class="label">IMAP Username (Почта):</div>
                  <b-form-input v-model="smtpSettings.pop_username" disabled size="sm" required class="form-control" />
                </div>
                <div class="d-flex profile_info_label mt-2">
                  <div class="label">IMAP Пароль:</div>
                  <b-form-input v-model="smtpSettings.pop_password" size="sm" required class="form-control" type="password" />
                </div>
                <div class="d-flex profile_info_label mt-2">
                  <div class="label">IMAP Шифрование:</div>
                  <b-form-input v-model="smtpSettings.pop_encryption" size="sm" required class="form-control" />
                </div>
                <div class="mt-2 text-right">
                  <b-button 
                    @click="toggleEditMode"
                    v-if="editMode && !savingProcess"
                    class="mr-2"
                  >Отменить</b-button>   

                  <b-button
                    @click="saveUserSettings" 
                    class="btn btn-primary"
                    :disabled="savingProcess"
                  >Сохранить<i class="fas fa-spinner fa-spin ml-1" v-if="savingProcess"></i></b-button >
                </div>
              </div>
            </b-overlay>
          </div>
        </div>
      </div>

      <div class="row mt-2" v-if="!isLeadObserver && smtpSettings.id">
        <div class="col-md-12">
          <div class="profile_info_block">
            <div class="profile_info_header_wrap position-relative">
              <span class="profile_info_header text-brown">Проверка почтовых настроек</span>
            </div>
            
            <b-overlay 
              :show="loadingData"
              opacity="1"
            >
              <div class="profile_info mt-3" v-if="!editMode && !loadingData">
                <div class="d-flex profile_info_label mb-2">
                  <div class="label">Проверка отправки почты:</div>
                  <div class="d-flex justify-content-space-between" style="width: 58%;">
                    {{ smtpSettings.test_send_email_date || 'Не проверялось' }}
                    <b-button 
                      @click="sendEmail"
                      class="ml-5 btn-sm"
                      :disabled="sendingTestEmail"
                      :variant="!smtpSettings.test_send_email_date ? 'outline-secondary':'outline-success'"
                    >
                      <template v-if="smtpSettings.test_send_email_date">
                        Успешно проверено!
                      </template>
                      <template v-else>
                        Запустить проверку
                      </template>
  
                      <i class="fas fa-spinner fa-spin ml-1" v-if="sendingTestEmail"></i>
                    </b-button>
                  </div>
                </div>
                <div class="d-flex profile_info_label">
                  <div class="label">Проверка входящей почты:</div>
                  <div class="d-flex justify-content-space-between" style="width: 58%;">
                    {{ smtpSettings.test_incoming_email_date || 'Не проверялось' }}
                    <b-button 
                      @click="checkEmail"
                      class="ml-5 btn-sm"
                      :disabled="checkingInboxEmail"
                      :variant="!smtpSettings.test_incoming_email_date ? 'outline-secondary':'outline-success'"
                    >
                      <template v-if="smtpSettings.test_incoming_email_date">
                        Успешно проверено!
                      </template>
                      <template v-else>
                        Запустить проверку
                      </template>
                      
                      <i class="fas fa-spinner fa-spin ml-1" v-if="checkingInboxEmail"></i>
                    </b-button>
                  </div>
                </div>
              </div>
            </b-overlay>
          </div>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-md-12">
          <div class="profile_info_block">
            <div class="profile_info">
              <div class="profile_info_label">
                <div class="label mt-2">
                  <b-button
                    variant="outline-secondary"
                    :class="historyOfLogins ? null : 'collapsed'"
                    :aria-expanded="historyOfLogins ? 'true' : 'false'"
                    aria-controls="collapse-historyOfLogins"
                    @click="historyOfLogins = !historyOfLogins"
                  >
                    <span v-if="!historyOfLogins">Открыть историю входов</span>
                    <span v-if="historyOfLogins">Закрыть историю входов</span>
                  </b-button>   
                  <b-button
                    v-if="historyOfLogins"
                    variant="secondary"
                    @click="getUserLogins()"
                  >
                  <b-icon
                    icon="arrow-repeat"
                    scale="1"
                    aria-label="Reload"
                    :animation="loading_user_logins ? 'spin' : ''"
                  />
                  </b-button>                                 
                </div>
                <b-collapse id="collapse-historyOfLogins" v-model="historyOfLogins" class="mt-2">
                  <b-card>
                    <div>
                      <ul>
                        <li
                          v-for="login in user_logins"
                          :key="login.login_at"
                        >
                          {{login.login_at}} {{login.ip}} {{login.browser}}
                        </li>
                      </ul>
                    </div>                    
                  </b-card>
                </b-collapse>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      ref="uploadNewPhoto"
      title="Загрузка новой фотографии"
      size="lg"
      hide-footer
      centered
    >
      <div>
        <div class="text-center mb-2">
          <span
            >Клиентам и коллегам будет проще узнать вас, если вы загрузите свою
            настоящую фотографию. <br />
            Вы можете загрузить изображение в формате JPG, GIF или PNG.</span
          >
        </div>
        <div>
          <div class="d-flex justify-content-center">
            <vue-avatar
              :width="200"
              :height="200"
              :border="0"
              ref="vueavatar"
              @vue-avatar-editor:image-ready="onImageReady"
            >
            </vue-avatar>
            <img ref="image" class="d-none" />
          </div>
        </div>
        <div class="align-items-center d-flex justify-content-between mt-2">
          <div>
            <small id="info-position-photo" class="d-none"
              >Выбранная область будет показываться на вашей странице.</small
            >
          </div>
          <div>
            <button
              id="upload-photo"
              @click="saveClicked"
              class="btn btn-sm btn-primary mr-2 px-3 border-5"
              disabled
            >
              Обновить фотографию
            </button>
            <button
              @click="showModalUploadPhoto('hide')"
              class="btn btn-sm btn-secondary px-3 border-5"
            >
              Отмена
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
  <div>
    <template v-if="this.currentUser.id == 1">
      <PushServiceAdmin />
    </template>
  </div>
  </b-card-text>
  </b-card>
</div>
</template>

<script>
import { VueAvatar } from "vue-avatar-editor-improved";

import {
  defaultDataItems,
} from '@/mixins'

import { API_USER_AVATARS, USER_LOGINS, API_USERS } from "../constants";
import { mapGetters } from "vuex";
import PushServiceAdmin from "./../components/notifications/PushServiceAdmin.vue";
import PasswordChangeForm from "./../components/common/PasswordChangeForm.vue";

export default {
  mixins: [
    defaultDataItems,
  ],  
  data: () => ({
      typeList: [
        { text: 'Яндекс', value: 'Yandex' },
        { text: 'NIC', value: 'NIC' },,
        { text: 'Свой', value: 'Custom' },
      ],    
      user_logins: [],
      loading_user_logins: false,
      editMode: false,
      loadingData: true,
      loading: false,
      showPasswordChange: false,
      sendingTestEmail: false,
      checkingInboxEmail: false,
      savingProcess: false,
      user: {},
      smtpSettings: {
        name: 'Custom',
        smtp_host: '',
        smtp_port: '',
        smtp_username: '',
        smtp_password: '',
        smtp_encryption: '',
        pop_host: '',
        pop_port: '',
        pop_username: '',
        pop_password: '',
        pop_encryption: '',
        test_send_email_date: '',
        test_incoming_email_date: ''
      },
      historyOfLogins: false
  }),
  components: {
    VueAvatar,
    PushServiceAdmin,
    PasswordChangeForm
  },

  watch: {
    currentUser: {
      handler(user) {
        this.user = JSON.parse(JSON.stringify(user));
      },
      deep: true,
      immediate: true
    },    
    smtpSettings: {
      handler(smtpSettings) {
        if (this.smtpSettings.name != 'Custom') {
          if (this.smtpSettings.name == 'Yandex') {
            this.smtpSettings.smtp_host = 'smtp.yandex.ru';
            this.smtpSettings.smtp_port = '587';
            this.smtpSettings.smtp_username = this.smtpSettings.smtp_username == '' ? this.currentUser.email : this.smtpSettings.smtp_username;
            this.smtpSettings.smtp_encryption = 'tls';

            this.smtpSettings.pop_host = 'imap.yandex.ru';
            this.smtpSettings.pop_port = '993';
            this.smtpSettings.pop_username = this.smtpSettings.pop_username == '' ? this.currentUser.email : this.smtpSettings.pop_username;
            this.smtpSettings.pop_encryption = 'ssl';
          } else if (this.smtpSettings.name == 'NIC') {
            this.smtpSettings.smtp_host = 'mail.nic.ru';
            this.smtpSettings.smtp_port = '465';
            this.smtpSettings.smtp_username = this.smtpSettings.smtp_username == '' ? this.currentUser.email : this.smtpSettings.smtp_username;
            this.smtpSettings.smtp_encryption = 'SSL';

            this.smtpSettings.pop_host = 'mail.nic.ru';
            this.smtpSettings.pop_port = '993';
            this.smtpSettings.pop_username = this.smtpSettings.pop_username == '' ? this.currentUser.email : this.smtpSettings.pop_username;
            this.smtpSettings.pop_encryption = 'SSL';
          }
        }
      },
      deep: true,
    },    
  },

  computed: {
    ...mapGetters("auth", ["currentUser"]),
    isLeadObserver() {
      return this.currentUser.role && this.currentUser.role.includes('lead-observer');
    },
  },

  mounted() {
    if (!this.isLeadObserver) {
      this.fetchSmtpSettings();
    } else {
      this.loadingData = false;
    }
    this.getUserLogins();
  },

  methods: {
    toggleEditMode() {
      this.editMode = !this.editMode;
    },

    saveUserSettings() {
      this.savingProcess = true;

      const user = {
        email: this.user.email,
        name: this.user.name,
        position: this.user.position,
        phone: this.user.phone
      };

      api.call("put", `${API_USERS}/${this.currentUser.id}`, user)
        .then((response) => {
          // Update Vuex store with new user data
          this.$store.commit('auth/USER_SUCCESS', response.data);
          // Update localStorage with new user data
          localStorage.setItem('user', JSON.stringify(response.data));

          if (!this.isLeadObserver) {
            this.saveSmtpSettings();
          } else {
            this.editMode = false;
            this.savingProcess = false;
          }

          this.makeToast('success', 'Настройки профиля успешно сохранены!', 6000)
        })
        .catch(error => {
          console.error(error);

          this.makeToast('danger', 'Проверьте указанные данные! Все поля должны быть заполнены.', 6000)
        })
        // .finally(() => );      
    },

    fetchSmtpSettings() {
      this.loadingData = true;

      api.call("get", `${API_USERS}/smtp-settings`)
        .then((response) => {
          if (response.data['smtp_host']) {
            this.smtpSettings = response.data;
          }
        })
        .finally(() => this.loadingData = false);      
    },

    saveSmtpSettings() {
      this.savingProcess = true;

      api.call("post", `${API_USERS}/smtp-settings`, this.smtpSettings)
        .then((response) => {
          this.editMode = false;

          this.makeToast('success', 'Почтовые настройки успешно сохранены!', 6000)
        })
        .catch(error => {
          console.error(error);

          this.makeToast('danger', 'Проверьте указанные данные! Все поля должны быть заполнены.', 6000)
        })
        .finally(() => this.savingProcess = false);      
    },
    
    sendEmail() {
      this.sendingTestEmail = true;

      let email = {
        'to': this.smtpSettings.smtp_username,
        'subject': 'Тестовое письмо из системы Tanasoft',
        'body': `Добрый день, ${this.currentUser.name}! \n\nЕсли вы видите это письмо, значит настройки для отправки почты выполнены верно. Посмотрите, как выглядит подпись к письму, если что скорректируйте в настройках профиля.`,
      }

      api.call("post", `/api/mailing/send-from-user`, email)
        .then((response) => {
          console.log("response", response);
          this.smtpSettings.test_send_email_date = response.data.date;
          this.makeToast('success', 'Тестовое письмо успешно отправлено на ваш email! Посмотрите, все ли хорошо выглядит.', 6000)
        })
        .catch(error => {
          console.error(error);
          this.smtpSettings.test_send_email_date = null;
          this.makeToast('danger', 'Ошибка отправки тестового письма. Проверьте настройки SMTP еще раз.', 6000)
        })
        .finally(() => this.sendingTestEmail = false);      
    },

    checkEmail() {
      this.checkingInboxEmail = true;

      api.call("get", `/api/mailing/check-emails`)
        .then((response) => {
          console.log("response", response);
          this.smtpSettings.test_incoming_email_date = response.data.date;
          this.makeToast('success', 'Проверка входящей почты выполнена успешно.', 6000)
        })
        .catch(error => {
          console.error(error);
          this.smtpSettings.test_incoming_email_date = null;
          this.makeToast('danger', 'Проверка входящей почты не удалась! Проверьте настройки IMAP.', 6000)
        })
        .finally(() => this.checkingInboxEmail = false);      
    },

    getUserLogins(){
      this.loading_user_logins = true;

      api
        .call("get", USER_LOGINS)
        .then(({data}) => this.user_logins = data)
        .finally(() => this.loading_user_logins = false);
    },

    showModalUploadPhoto(statement) {
      this.$refs["uploadNewPhoto"][statement]();
    },

    saveClicked() {
      var img = this.$refs.vueavatar.getImageScaled();
      this.$refs.image.src = img.toDataURL();
      const avatarUsers = {
        user_id: this.currentUser.id,
        avatar: img.toDataURL(),
      };

      api
        .call("post", API_USER_AVATARS, { params: avatarUsers })
        .then(({ data }) => {
          this.handlerAddUserPhoto = false;
          this.$set(this.currentUser, "avatar_path", data);
          // this.user.avatar_path = data
          this.$store.dispatch("UPDATE_USER", this.currentUser);
          this.$emit("updateUser", this.currentUser);
          this.$refs.vueavatar.resetImage();
          this.showModalUploadPhoto("hide");
        });
    },

    onImageReady() {
      let btn = document.getElementById("upload-photo"),
        infoLabel = document.getElementById("info-position-photo");

      btn.disabled = false;
      infoLabel.classList.remove("d-none");

      this.scale = 1;
      this.rotation = 0;
    },
  },
};
</script>
<style scoped>
  .edit-button {
    position: absolute;
    top: 0;
    right: 0;
  }
  .custom-select {
    height: 35px !important;
    line-height: 15px;
    border-radius: 2px;
    margin-left: 2px;
    padding-left: 7px;
  }
  pre {
    line-height: 100%;
  }
  .email-sign {
    font-size: 14px;
    line-height: 21px;
    margin-bottom: 25px;
  }
  
  /* Стили для блоков профиля */
  .profile_info_label {
    margin-bottom: 8px;
    padding: 6px 0;
    border-bottom: 1px solid #e9ecef;
  }
  
  .profile_info_label:last-child {
    border-bottom: none;
    margin-bottom: 0;
  }
  
  .profile_info_label .label {
    font-weight: 600;
    color: #495057;
    margin-bottom: 3px;
    font-size: 14px;
  }
  
  .profile_info_label > div:not(.label) {
    color: #212529;
    font-size: 15px;
    line-height: 1.3;
  }
  
  /* Мобильная адаптация для блоков профиля */
  @media (max-width: 768px) {
    .profile_info_label {
      flex-direction: column !important;
      align-items: flex-start !important;
      padding: 8px 0;
      margin-bottom: 6px;
    }
    
    .profile_info_label .label {
      margin-bottom: 4px;
      font-size: 13px;
      color: #6c757d;
      font-weight: 500;
    }
    
    .profile_info_label > div:not(.label) {
      font-size: 14px;
      width: 100%;
      word-break: break-word;
      line-height: 1.3;
    }
    
    /* Специальные стили для полей ввода в режиме редактирования */
    .profile_info_label .form-control {
      margin-top: 3px;
      width: 100% !important;
    }
    
    /* Адаптация для кнопок в блоках проверки почты */
    .profile_info_label .d-flex.justify-content-space-between {
      flex-direction: column !important;
      width: 100% !important;
    }
    
    .profile_info_label .d-flex.justify-content-space-between > div:first-child {
      margin-bottom: 8px;
    }
    
    .profile_info_label .btn {
      width: 100%;
      margin-left: 0 !important;
    }
  }
  
  /* Дополнительная адаптация для очень маленьких экранов */
  @media (max-width: 480px) {
    .profile_info_label {
      padding: 6px 0;
      margin-bottom: 5px;
    }
    
    .profile_info_label .label {
      font-size: 12px;
      margin-bottom: 3px;
    }
    
    .profile_info_label > div:not(.label) {
      font-size: 13px;
    }
  }
</style>